/**
 * Specifies the linear gauge constant value
 */
/** @private */
export var loaded = 'loaded';
/** @private */
export var load = 'load';
/** @private */
export var animationComplete = 'animationComplete';
/** @private */
export var axisLabelRender = 'axisLabelRender';
/** @private */
export var tooltipRender = 'tooltipRender';
/** @private */
export var annotationRender = 'annotationRender';
/** @private */
export var gaugeMouseMove = 'gaugeMouseMove';
/** @private */
export var gaugeMouseLeave = 'gaugeMouseLeave';
/** @private */
export var gaugeMouseDown = 'gaugeMouseDown';
/** @private */
export var gaugeMouseUp = 'gaugeMouseUp';
/** @private */
export var dragStart = 'dragStart';
/** @private */
export var dragMove = 'dragMove';
/** @private */
export var dragEnd = 'dragEnd';
/** @private */
export var valueChange = 'valueChange';
/** @private */
export var resized = 'resized';
/** @private */
export var beforePrint = 'beforePrint';
